import API from './../api';
import {
    WORDPRESS_SETTINGS_WEBSITE_BY_ID_ENDPOINT,
    WORDPRESS_SETTINGS_WEBSITES_ENDPOINT
} from '../endpoints';

export default {
    namespaced: true,

    state() {
        return {
            websites: [],
            currentWebsitePage: null,
            websitesProperties: [],
            websitesCategories: [],
        };
    },

    getters: {
        websites: (state) => state.websites,
        currentWebsitePage: (state) => state.currentWebsitePage,
        currentWebsitesProperties: (state) => (id) => {
            const websiteProperties = state.websitesProperties.find(item => item.id === id) || {};

            return websiteProperties && websiteProperties.list;
        },
        currentWebsitesCategories: (state) => (id) => {
            const websiteCategories = state.websitesCategories.find(item => item.id === id);

            return websiteCategories && websiteCategories.list;
        },
        websitePageByID: (state) => (id) => state.websites.find(item => item.id === id),
    },
    mutations: {
        getWebsites(state, response) {
            state.websites = response.data || [];
        },
        assignFirstCurrentWebsitePage(state) {
            state.currentWebsitePage = state.websites[0];
        },
        assignCurrentWebsitePage(state, { id }) {
            state.currentWebsitePage = state.websites.find(item => item.id === id);
        },
        updateCurrentWebsitePage(state, { data }) {
            if (!state.currentWebsitePage) {
                return false;
            }
            state.currentWebsitePage = { ...state.currentWebsitePage, ...data };
        },
        updateWebsites(state, { data }) {
            state.websites = state.websites.map(i => {
                if (i.id === data.id) {
                    return data
                }

                return  i;
            });
        },
        addNewWebsite(state, response) {
            state.websites = [...state.websites, response.data];
        },
        removeWebsite(state, { id }) {
            state.websites = state.websites.filter(i => i.id !== id);
        },
        setWebsiteProperties(state, { id, list }) {
            state.websitesProperties = [...state.websitesProperties, { id, list }];
        },
        setWebsiteCategories(state, { id, list }) {
            state.websitesCategories = [...state.websitesCategories, { id, list }];
        },
        resetWebsitesData(state) {
            state.websites = [];
            state.currentWebsitePage = null;
            state.websitesProperties = [];
            state.websitesCategories = [];
        }
    },
    actions: {
        async fetchWordpressWebsites({ commit }) {
            commit('getWebsites', await API.get(WORDPRESS_SETTINGS_WEBSITES_ENDPOINT()));
        },
        async addWordpressWebsite({ commit }) {
            commit('addNewWebsite', await API.post(WORDPRESS_SETTINGS_WEBSITES_ENDPOINT()));
        },
        async removeWordpressWebsite({ commit, state }, { id }) {
            await API.delete(WORDPRESS_SETTINGS_WEBSITE_BY_ID_ENDPOINT(id));
            commit('removeWebsite', { id });
            if (state.currentWebsitePage.id === id) {
                commit('assignFirstCurrentWebsitePage');
            }
        },
        async updateWebsite({ commit, state }, { id, data }) {
            await API.put(WORDPRESS_SETTINGS_WEBSITE_BY_ID_ENDPOINT(id), data);
            await commit('updateCurrentWebsitePage', { data });
            commit('updateWebsites', { data: state.currentWebsitePage });
        },
        setLoadedProperties({ commit }, { id, list }) {
            commit('setWebsiteProperties', { id, list });
        },
        setLoadedCategories({ commit }, { id, list }) {
            commit('setWebsiteCategories', { id, list });
        },
        resetAllWebsitesData({ commit }) {
            commit('resetWebsitesData');
        }
    },
};
